export default __webpack_public_path__ + "images/WatermarkHand-Regular.font.59ef7c9be6516348e36fd2445ff8f5d2.svg";